// extracted by mini-css-extract-plugin
export default {"main":"style_main__W4Icr","leftMenu":"style_leftMenu__fhsEq","right":"style_right__HniwQ","title":"style_title__tvGLa"};